module.exports = __webpack_public_path__ + "static/media/one-ball.e18dfbb3.png";